/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerMaintenanceScopeOptionClaimedByDto } from './PartnerMaintenanceScopeOptionClaimedByDto';
import {
    PartnerMaintenanceScopeOptionClaimedByDtoFromJSON,
    PartnerMaintenanceScopeOptionClaimedByDtoFromJSONTyped,
    PartnerMaintenanceScopeOptionClaimedByDtoToJSON,
    PartnerMaintenanceScopeOptionClaimedByDtoToJSONTyped,
} from './PartnerMaintenanceScopeOptionClaimedByDto';

/**
 * 
 * @export
 * @interface PartnerMaintenanceScopeOptionDto
 */
export interface PartnerMaintenanceScopeOptionDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeOptionDto
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeOptionDto
     */
    label: string;
    /**
     * 
     * @type {PartnerMaintenanceScopeOptionClaimedByDto}
     * @memberof PartnerMaintenanceScopeOptionDto
     */
    claimedBy?: PartnerMaintenanceScopeOptionClaimedByDto | null;
    /**
     * 
     * @type {Array<PartnerMaintenanceScopeOptionClaimedByDto>}
     * @memberof PartnerMaintenanceScopeOptionDto
     */
    claims?: Array<PartnerMaintenanceScopeOptionClaimedByDto>;
}

/**
 * Check if a given object implements the PartnerMaintenanceScopeOptionDto interface.
 */
export function instanceOfPartnerMaintenanceScopeOptionDto(value: object): value is PartnerMaintenanceScopeOptionDto {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function PartnerMaintenanceScopeOptionDtoFromJSON(json: any): PartnerMaintenanceScopeOptionDto {
    return PartnerMaintenanceScopeOptionDtoFromJSONTyped(json, false);
}

export function PartnerMaintenanceScopeOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMaintenanceScopeOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'label': json['label'],
        'claimedBy': json['claimedBy'] == null ? undefined : PartnerMaintenanceScopeOptionClaimedByDtoFromJSON(json['claimedBy']),
        'claims': json['claims'] == null ? undefined : ((json['claims'] as Array<any>).map(PartnerMaintenanceScopeOptionClaimedByDtoFromJSON)),
    };
}

export function PartnerMaintenanceScopeOptionDtoToJSON(json: any): PartnerMaintenanceScopeOptionDto {
    return PartnerMaintenanceScopeOptionDtoToJSONTyped(json, false);
}

export function PartnerMaintenanceScopeOptionDtoToJSONTyped(value?: PartnerMaintenanceScopeOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
        'claimedBy': PartnerMaintenanceScopeOptionClaimedByDtoToJSON(value['claimedBy']),
        'claims': value['claims'] == null ? undefined : ((value['claims'] as Array<any>).map(PartnerMaintenanceScopeOptionClaimedByDtoToJSON)),
    };
}

